import {
  ALL_CAREERS_FAIL,
  ALL_CAREERS_SUCCESS,
  CLEAR_ERRORS,
  LOAD_CAREER_FAIL,
  LOAD_CAREER_REQUEST,
  LOAD_CAREER_SUCCESS,
  LOGIN_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT_FAIL,
  LOGOUT_SUCCESS,
} from "app/utils/constants/careerConstants";

const INIT_STATE = {
  loading: false,
  isAuthenticated: false,
  error: null,
  allCareer: [],
  TotalPage: null,
};

export const careerReducer = (state = { client: INIT_STATE }, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case LOAD_CAREER_REQUEST:
      return {
        ...state,
        loading: true,
        isAuthenticated: false,
      };
    case LOGIN_SUCCESS:
    case LOAD_CAREER_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        career: action.payload,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        career: null,
        error: action.payload,
      };
    case LOAD_CAREER_FAIL:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        career: null,
        error: action.payload,
      };
    case ALL_CAREERS_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        allCareer: action.payload.data,
        TotalPage: action.payload.totalPage,
      };
    case ALL_CAREERS_FAIL:
      return {
        ...state,
        allCareers: [],
        error: action.payload,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        career: null,
        allCareers: [],
      };
    case LOGOUT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};
